// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./augmentations/bson.d.ts" />

// We had to specifically import ObjectId from a CommonJS file to prevent it from causing issues with the frontend build
// But it's unclear if that's still necessary, so it's been switched back to an ESM file after that caused problems with the chrome extension
import { ObjectId } from 'bson';

// Copied from mongoose
Object.defineProperty(ObjectId.prototype, '_id', {
  enumerable: false,
  configurable: true,
  get: function () {
    return this;
  },
});
export { ObjectId };
export { EJSON } from 'bson';
